
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Prompt, useLocation, useHistory } from "react-router-dom";
import CustomModal from "../../hoc/CustomModal";
import UpdatePop from "./UpdatePop";

const RouterPrompt = ({ content, title, isBlocked, subTitle }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const location = useLocation();
    const history = useHistory();
    const [lastLocation, setLastLocation] = useState(location);
    const [shouldUnload, setShouldUnload] = useState(false);
    const [confirmedNavigation, setConfirmedNavigation] = useState(false);

    const closeModal = () => {
        setIsModalOpen(false);
        setShouldUnload(false);
    };

    const openModal = (nextLocation) => {
        if (nextLocation.pathname === "/hosted-payments" || nextLocation.pathname === "/dashboard" || nextLocation?.hostname === "convergepay") {
            setConfirmedNavigation(true);
            return false
        }
        setIsModalOpen(true);
    };

    const showModal = (nextLocation) => {        
        openModal(nextLocation);
        setLastLocation(nextLocation);
    };

    const handleBlockedRoute = (nextLocation) => {
        if (!confirmedNavigation && isBlocked) {
            showModal(nextLocation);
            return false;
        }
        return true;
    };

    const handleConfirmNavigationClick = () => {
        closeModal();
        setConfirmedNavigation(true);
    };

    // Block react routes
    useEffect(() => {
        if (confirmedNavigation && lastLocation) {
            // Navigate to the previous blocked location with your navigate function
            setShouldUnload(true);
            history.push(lastLocation.pathname);
        }
    }, [confirmedNavigation, lastLocation, history]);

    // Block non-react routes
    useEffect(() => {
        const unload = (event) => {
            if (isBlocked && !shouldUnload) {
                event.returnValue = content;
            }
            if (shouldUnload) {
                event.returnValue = "";
            }
        };
        window.addEventListener("beforeunload", unload);
        return () => window.removeEventListener("beforeunload", unload);
    }, [isBlocked, content, shouldUnload]);

    return (
        <>
            <Prompt when message={handleBlockedRoute} />
            {isModalOpen && (
                <CustomModal  open={isModalOpen} handleOpen={closeModal}>
                    <UpdatePop subTitle={subTitle} setUpdatePop={closeModal} updateCourse={handleConfirmNavigationClick} tittle={title} desc={content} />
                </CustomModal>
            )}
        </>
    );
};

RouterPrompt.propTypes = {
    content: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    isBlocked: PropTypes.bool.isRequired
};

export default RouterPrompt;